
export let Exports = {
    // tslint:disable-next-line: max-line-length
    emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
    nameRegex: /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
    companyNameRegex: /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ0-9\s]+$/,
    highchartsLang: {
        loading: 'Aguarde...',
        months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        exportButtonTitle: 'Exportar',
        printButtonTitle: 'Imprimir',
        rangeSelectorFrom: 'De',
        rangeSelectorTo: 'Até',
        rangeSelectorZoom: 'Periodo',
        downloadPNG: 'Download imagem PNG',
        downloadJPEG: 'Download imagem JPEG',
        downloadPDF: 'Download documento PDF',
        downloadSVG: 'Download imagem SVG',
    }
}

export const webAppTokenQueryParamName = 'web-app-token';
export const registerTokenQueryParamName = 'register-token';
export const webAppLoginRedirectParamName = 'redirect';
export const ignorePreviousUserParamName = 'force-logout';
// tslint:disable-next-line: no-empty
export const fakeFunction = () => {};
export const minIncomeValue = 30;
export const STOCK_LOGO_PLACEHOLDER = 'https://cdn.toroinvestimentos.com.br/corretora/images/quote/NO-LOGO.svg';
